import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateEventContact($companyId: ID!, $attributes: EventContactAttributes!) {
    createEventContact(companyId: $companyId, attributes: $attributes) {
      eventContact {
        id
        ...CreatedEventContact
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedEventContact on EventContact {
    id
    name
    email
    phone
    color
    contactType
    user { id displayName email }
  }
`
